import { render, staticRenderFns } from "./Intellimat.vue?vue&type=template&id=92bc8298&scoped=true&"
import script from "./Intellimat.vue?vue&type=script&lang=js&"
export * from "./Intellimat.vue?vue&type=script&lang=js&"
import style0 from "./Intellimat.vue?vue&type=style&index=0&id=92bc8298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bc8298",
  null
  
)

component.options.__file = "Intellimat.vue"
export default component.exports